exports.components = {
  "component---src-components-generic-page-generic-page-template-js": () => import("./../../../src/components/GenericPage/GenericPageTemplate.js" /* webpackChunkName: "component---src-components-generic-page-generic-page-template-js" */),
  "component---src-components-guide-singola-guida-js": () => import("./../../../src/components/Guide/SingolaGuida.js" /* webpackChunkName: "component---src-components-guide-singola-guida-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

